import PullableWrapper from '@/components/PullableWrapper';
import SvgInset from '@/components/SvgInset';
import { CDN_URL_ICONS } from '@/configs';
import { ROUTE_PATH } from '@/constants/route-path';
import { AssetsContext } from '@/contexts/assets-context';
import { CurrencyContext } from '@/contexts/currency-context';
import { WalletContext } from '@/contexts/wallet-context';
import withPWAMiddleware from '@/hocs/withAlphaMiddleware';
import useGameFiWallet from '@/hooks/useGameFiWallet';
import useOpenDepositModal from '@/hooks/useOpenDepositModal';
import { IGetPlayerPoolProfile } from '@/interfaces/api/player-share';
import { initializeFCM } from '@/services/firebase/messaging';
import {autoFollowHoldings, getPlayerPoolProfile, syncProfileData} from '@/services/player-share';
import { getAddressReferrer } from '@/services/referral';
import { useAppDispatch } from '@/state/hooks';
import { openModal } from '@/state/modal';
import { formatCurrency } from '@/utils';
import accountStorage from '@/utils/account.storage';
import { formatTCAddress } from '@/utils/format';
import { getPermissionStatus, isPermissionGranted } from '@/utils/notification';
import {
  Box,
  Flex,
  Grid,
  Menu,
  MenuButton,
  MenuList,
  Spinner,
  useDisclosure,
} from '@chakra-ui/react';
import cn from 'classnames';
import cs from 'classnames';
import copy from 'copy-to-clipboard';
import { useRouter } from 'next/router';
import { useContext, useEffect, useState } from 'react';
import { toast } from 'react-hot-toast';
import { TbRefresh } from 'react-icons/tb';
import PlayerSharesIframe from '../Leaderboard/PlayerSharesIframe';
import IcMenuMinKey from '../Profiles/TradeKey/assets/icons/icMenuMinKey';
import Avatar from '../Profiles/TradeKey/components/avatar';
import EnterInviteCodeModal from './EnterInviteCodeModal';
import InviteAndRewards from './InviteAndRewards';
import MinKeyRequirement from './MinKeyRequirement';
import ModalGuideNoti, { GUIDE_NOTI_MODAL } from './Modal/ModalGuideNoti';
import s from './Profile.module.scss';
import SwapTcToBTCModal from './SwapTcToBtcModal';
import WithdrawModal from './WithdrawModal';
import BigNumber from 'bignumber.js';
import SettingCreatorFee from './SettingCreatorFee';
import { labelAmountOrNumberAdds } from '../Profiles/TradeKey/constants';
import { IoMdClose } from 'react-icons/io';
import useTradeKey from '@/hooks/playerShareToken/useTradeKey';
import { formatFeePercent } from '@/utils/helpers';
import { useRateBTCUSDT } from '@/hooks/useRateBTCUSDT';
import {IcEnableNotification} from "@/modules/AlphaPWA/Profile/svgs/ic-enable-notification";
import {IcAutoFollow} from "@/modules/AlphaPWA/Profile/svgs/ic-auto-follow";
import {requestReload, selectCommonReducer} from "@/state/common";
import {useSelector} from "react-redux";

const EnterInviteCodeIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.6959 9.19668C11.3959 9.49668 11.0176 9.68747 10.6084 9.7583V10C10.6084 10.345 10.3284 10.625 9.98342 10.625C9.63842 10.625 9.35842 10.345 9.35842 10V9.75667C8.49842 9.59417 7.82176 8.88749 7.72093 7.98665C7.68259 7.64332 7.92924 7.33417 8.27174 7.29584C8.60674 7.255 8.92425 7.50335 8.96259 7.84668C9.00759 8.24335 9.34091 8.54167 9.73758 8.54167H10.2626C10.4692 8.54167 10.6642 8.45998 10.8117 8.31248C10.9601 8.16415 11.0417 7.96912 11.0417 7.76245C11.0417 7.40495 10.7984 7.09415 10.4509 7.00582L9.24508 6.70664C8.80508 6.59498 8.41174 6.33919 8.13508 5.98419C7.86091 5.63669 7.70758 5.19255 7.70758 4.73755C7.70758 3.74838 8.41925 2.92502 9.35758 2.74668V2.5C9.35758 2.155 9.63758 1.875 9.98258 1.875C10.3276 1.875 10.6076 2.155 10.6076 2.5V2.74078C11.4826 2.89162 12.1759 3.60168 12.2784 4.51335C12.3168 4.85668 12.0701 5.16583 11.7276 5.20416C11.3917 5.24583 11.0751 4.99665 11.0367 4.65332C10.9917 4.25665 10.6584 3.95833 10.2617 3.95833H9.73674C9.30674 3.95833 8.95758 4.30755 8.95758 4.73755C8.95758 4.91172 9.01508 5.08084 9.11924 5.2125C9.22924 5.35417 9.37675 5.45003 9.54842 5.49337L10.7542 5.79254C11.6601 6.02171 12.2909 6.83164 12.2909 7.76164C12.2917 8.3033 12.0801 8.81251 11.6959 9.19668ZM5.00008 16.6667V13.3333C5.00008 12.8733 4.62675 12.5 4.16675 12.5H2.50008C2.04008 12.5 1.66675 12.8733 1.66675 13.3333V16.6667C1.66675 17.1267 2.04008 17.5 2.50008 17.5H4.16675C4.62675 17.5 5.00008 17.1267 5.00008 16.6667ZM16.3834 12.5167C16.1918 12.5167 16.0001 12.5666 15.8168 12.675L13.9251 13.8083C13.7501 14.8333 12.8501 15.625 11.7667 15.625H9.16675C8.82508 15.625 8.54175 15.3417 8.54175 15C8.54175 14.6583 8.82508 14.375 9.16675 14.375H11.7667C12.2834 14.375 12.7084 13.9583 12.7084 13.4333C12.7084 12.9167 12.2834 12.5 11.7667 12.5H7.50008C6.58341 12.5 5.83341 13.25 5.83341 14.1667V15.8333C5.83341 16.75 6.58341 17.5 7.50008 17.5H12.1668C12.9251 17.5 13.6584 17.2417 14.2501 16.7667L17.0834 14.5C17.3501 14.2917 17.5001 13.9667 17.5001 13.6333C17.5001 12.9833 16.9668 12.5167 16.3834 12.5167Z"
        fill="black"
      />
    </svg>
  );
};

export const JackpotProfile = ({ onClose }: { onClose?: () => void }) => {
  const dispatch = useAppDispatch();
  const { addressL2 } = useContext(WalletContext);
  const { balanceL2 } = useContext(AssetsContext);
  const { swapTC2BTCAble } = useContext(CurrencyContext);
  const { onViewKey } = useGameFiWallet();
  const router = useRouter();
  const {
    isOpen: isOpenCashOut,
    onOpen: onOpenCashOut,
    onClose: onCloseCashOut,
  } = useDisclosure({ id: 'cashout' });
  const {
    isOpen: isOpenEnterInviteCode,
    onOpen: onOpenEnterInviteCode,
    onClose: onCloseEnterInviteCode,
  } = useDisclosure({ id: 'enter_invite_code ' });
  const {
    isOpen: isOpenSwapTC,
    onOpen: onOpenEnterSwapTC,
    onClose: onCloseEnterSwapTC,
  } = useDisclosure({ id: 'swap_tc_btc' });

  const {
    isOpen: isOpenMinKeyRequirement,
    onOpen: onOpenMinKeyRequirement,
    onClose: onCloseMinKeyRequirement,
  } = useDisclosure({ id: 'min_key_requirement ' });

  const {
    isOpen: isOpenSettingCreatorFee,
    onOpen: onOpenSettingCreatorFee,
    onClose: onCloseSettingCreatorFee,
  } = useDisclosure({ id: 'setting_creator_fee ' });

  const [url, setUrl] = useState('');
  const [poolProfile, setPoolProfile] = useState<IGetPlayerPoolProfile | null>(
    null
  );
  const { handleOpenTopup, fetchingOtp, loading } = useOpenDepositModal();
  const [isReferralFromAnother, setIsReferralFromAnother] = useState(false);
  const notiPermission = isPermissionGranted();
  const [hasNotiPermission, setHasNotiPermission] = useState(notiPermission);
  const [isSyncProfile, setIsSyncProfile] = useState(false);
  const { userProfile } = useTradeKey();

  const [portfolioValueUSDT, setPortfolioValueUSDT] = useState(0);
  const [earningValueUSDT, setEarningValueUSDT] = useState(0);

  const rate = useRateBTCUSDT(true);

  const needReload = useSelector(selectCommonReducer).needReload;

  useEffect(() => {
    try {
      if (rate) {
        setPortfolioValueUSDT(rate * Number(poolProfile?.portfolio || '0'));
        setEarningValueUSDT(rate * Number(poolProfile?.earningFee || '0'));
      }
    } catch (e) {
      console.error(e);
    }
  }, [rate, poolProfile]);

  const fetchPlayerPoolProfile = async () => {
    if (!addressL2) return;
    try {
      const res = await getPlayerPoolProfile(addressL2);
      setPoolProfile(res);
    } catch (error) {
      console.log('🚀 ~ fetchPlayerPoolProfile ~ error:', error);
    }
  };

  useEffect(() => {
    getAddressReferrer().then(reference => {
      setIsReferralFromAnother(!!reference);
    });
  }, []);

  useEffect(() => {
    fetchPlayerPoolProfile();
  }, [addressL2, needReload]);

  const goToHolderDetail = () => {
    router.push({
      pathname: `${ROUTE_PATH.ALPHA_MOBILE_PROFILE}/${addressL2}`,
      query: { tab: 'HOLDER' },
    });
  };

  const goToHoldingDetail = () => {
    router.push({
      pathname: `${ROUTE_PATH.ALPHA_MOBILE_PROFILE}/${addressL2}`,
      query: { tab: 'HOLDING' },
    });
  };

  const goToOpenOrder = () => {
    router.push(`${ROUTE_PATH.ALPHA_MOBILE_TRADE_OPEN_ORDER}`);
  };

  const handleGetNotification = async () => {
    if (!addressL2) return;
    const permissionStatus = getPermissionStatus();
    if (permissionStatus === 'denied') {
      dispatch(
        openModal({
          id: GUIDE_NOTI_MODAL,
          theme: 'dark',
          modalProps: {
            centered: true,
            zIndex: 9999999,
          },
          render: () => <ModalGuideNoti />,
        })
      );
      return;
    }

    accountStorage.setShowedNotification();
    const isEnable = await initializeFCM(addressL2);
    if (isEnable) {
      setHasNotiPermission(true);
    }
  };

  if (!addressL2) return null;

  const handleSyncProfile = async () => {
    try {
      setIsSyncProfile(true);
      const res = await syncProfileData(addressL2);
      fetchPlayerPoolProfile();
    } catch (e) {
    } finally {
      setIsSyncProfile(false);
    }
  };

  const handleAutoFollowHolding = async () => {
    await autoFollowHoldings(addressL2, {auto_follow: !poolProfile?.autoFollow});
    dispatch(requestReload());
  }

  return (
    <PullableWrapper>
      <div className={cs(s.wrapper)}>
        <div className={s.wrapProfile}>
          <div className={s.profile}>
            <div className={s.profile_nav}>
              <div className={s.profile_left}>
                {onClose ? (
                  <IoMdClose onClick={() => onClose()} />
                ) : (
                  <svg
                    onClick={() => {
                      if (window.history.length > 1) {
                        router.back();
                      } else {
                        router.push(ROUTE_PATH.ALPHA_MOBILE_HOME);
                      }
                    }}
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M15.0003 20.0003C14.7443 20.0003 14.4883 19.9023 14.2933 19.7073L7.29325 12.7073C6.90225 12.3163 6.90225 11.6842 7.29325 11.2933L14.2933 4.29325C14.6842 3.90225 15.3163 3.90225 15.7073 4.29325C16.0983 4.68425 16.0983 5.31631 15.7073 5.70731L9.41434 12.0003L15.7073 18.2933C16.0983 18.6842 16.0983 19.3163 15.7073 19.7073C15.5123 19.9023 15.2563 20.0003 15.0003 20.0003Z"
                      fill="#E7E7E7"
                    />
                  </svg>
                )}
              </div>
              <p className={s.profile_label}> Wallet</p>
              <div className={s.profile_right}>
                <Menu>
                  <MenuButton pl="20px">
                    <svg
                      className={s.dots_icon}
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <g id="solar:menu-dots-bold">
                        <path
                          id="Vector"
                          d="M12 7C11.4696 7 10.9609 6.78929 10.5858 6.41421C10.2107 6.03914 10 5.53043 10 5C10 4.46957 10.2107 3.96086 10.5858 3.58579C10.9609 3.21071 11.4696 3 12 3C12.5304 3 13.0391 3.21071 13.4142 3.58579C13.7893 3.96086 14 4.46957 14 5C14 5.53043 13.7893 6.03914 13.4142 6.41421C13.0391 6.78929 12.5304 7 12 7ZM12 14C11.4696 14 10.9609 13.7893 10.5858 13.4142C10.2107 13.0391 10 12.5304 10 12C10 11.4696 10.2107 10.9609 10.5858 10.5858C10.9609 10.2107 11.4696 10 12 10C12.5304 10 13.0391 10.2107 13.4142 10.5858C13.7893 10.9609 14 11.4696 14 12C14 12.5304 13.7893 13.0391 13.4142 13.4142C13.0391 13.7893 12.5304 14 12 14ZM12 21C11.4696 21 10.9609 20.7893 10.5858 20.4142C10.2107 20.0391 10 19.5304 10 19C10 18.4696 10.2107 17.9609 10.5858 17.5858C10.9609 17.2107 11.4696 17 12 17C12.5304 17 13.0391 17.2107 13.4142 17.5858C13.7893 17.9609 14 18.4696 14 19C14 19.5304 13.7893 20.0391 13.4142 20.4142C13.0391 20.7893 12.5304 21 12 21Z"
                          fill="black"
                        />
                      </g>
                    </svg>
                  </MenuButton>
                  <MenuList py="16px" boxShadow="2xl" borderRadius={'8px'}>
                    <div className={s.wallet_block} onClick={onViewKey}>
                      <div className={s.wallet_block_left}>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="none"
                        >
                          <path
                            d="M17.5 7.29167C17.155 7.29167 16.875 7.01167 16.875 6.66667V3.75C16.875 3.25917 16.7408 3.125 16.25 3.125H13.3333C12.9883 3.125 12.7083 2.845 12.7083 2.5C12.7083 2.155 12.9883 1.875 13.3333 1.875H16.25C17.4242 1.875 18.125 2.57583 18.125 3.75V6.66667C18.125 7.01167 17.845 7.29167 17.5 7.29167ZM3.125 6.66667V3.75C3.125 3.25917 3.25917 3.125 3.75 3.125H6.66667C7.01167 3.125 7.29167 2.845 7.29167 2.5C7.29167 2.155 7.01167 1.875 6.66667 1.875H3.75C2.57583 1.875 1.875 2.57583 1.875 3.75V6.66667C1.875 7.01167 2.155 7.29167 2.5 7.29167C2.845 7.29167 3.125 7.01167 3.125 6.66667ZM7.29167 17.5C7.29167 17.155 7.01167 16.875 6.66667 16.875H3.75C3.25917 16.875 3.125 16.7408 3.125 16.25V13.3333C3.125 12.9883 2.845 12.7083 2.5 12.7083C2.155 12.7083 1.875 12.9883 1.875 13.3333V16.25C1.875 17.4242 2.57583 18.125 3.75 18.125H6.66667C7.01167 18.125 7.29167 17.845 7.29167 17.5ZM18.125 16.25V13.3333C18.125 12.9883 17.845 12.7083 17.5 12.7083C17.155 12.7083 16.875 12.9883 16.875 13.3333V16.25C16.875 16.7408 16.7408 16.875 16.25 16.875H13.3333C12.9883 16.875 12.7083 17.155 12.7083 17.5C12.7083 17.845 12.9883 18.125 13.3333 18.125H16.25C17.4242 18.125 18.125 17.4242 18.125 16.25ZM12.8475 8.13416V7.22168C12.8475 5.65168 11.57 4.37419 10 4.37419C8.43 4.37419 7.15251 5.65168 7.15251 7.22168V8.13416C6.27501 8.27916 5.83333 8.85911 5.83333 9.88078V13.4526C5.83333 14.6434 6.42839 15.2382 7.61922 15.2382H12.3808C13.5708 15.2382 14.1667 14.6434 14.1667 13.4526V9.88078C14.1667 8.85911 13.725 8.27916 12.8475 8.13416ZM10.625 11.9342V12.7783C10.625 13.1233 10.345 13.4033 10 13.4033C9.655 13.4033 9.375 13.1233 9.375 12.7783V11.9132C9.135 11.7224 8.97074 11.4408 8.97074 11.1117C8.97074 10.5367 9.43334 10.07 10.0083 10.07H10.0167C10.5917 10.07 11.0583 10.5367 11.0583 11.1117C11.0583 11.4542 10.8808 11.7442 10.625 11.9342ZM8.40251 8.09509V7.22168C8.40251 6.34085 9.11917 5.62419 10 5.62419C10.8808 5.62419 11.5975 6.34085 11.5975 7.22168V8.09509H8.40251Z"
                            fill="#1C1C1C"
                          />
                        </svg>
                        <p>Export private key</p>
                      </div>
                    </div>
                    {/*<div*/}
                    {/*  className={s.wallet_block}*/}
                    {/*  onClick={() => {*/}
                    {/*    router.push(ROUTE_PATH.ALPHA_MOBILE_IMPORT_KEY);*/}
                    {/*  }}*/}
                    {/*>*/}
                    {/*  <div className={s.wallet_block_left}>*/}
                    {/*    <svg*/}
                    {/*      xmlns="http://www.w3.org/2000/svg"*/}
                    {/*      width="20"*/}
                    {/*      height="20"*/}
                    {/*      viewBox="0 0 20 20"*/}
                    {/*      fill="none"*/}
                    {/*    >*/}
                    {/*      <path*/}
                    {/*        d="M8.01676 4.58333C5.86676 4.58333 4.58333 5.86666 4.58333 8.01666V13.8958C4.58333 14.0417 4.45408 14.1642 4.30908 14.15C3.10742 14.03 2.5 13.3033 2.5 11.9833V4.68333C2.5 3.23333 3.23343 2.5 4.68343 2.5H11.9832C13.3032 2.5 14.03 3.10752 14.15 4.30918C14.165 4.45418 14.0425 4.58333 13.8967 4.58333H8.01676ZM17.5 8.02083V15.3125C17.5 16.7708 16.7708 17.5 15.3125 17.5H8.02083C6.5625 17.5 5.83333 16.7708 5.83333 15.3125V14.1667V8.02083C5.83333 6.5625 6.5625 5.83333 8.02083 5.83333H14.1667H15.3125C16.7708 5.83333 17.5 6.5625 17.5 8.02083ZM14.375 11.6667C14.375 11.3217 14.095 11.0417 13.75 11.0417H12.2917V9.58333C12.2917 9.23833 12.0117 8.95833 11.6667 8.95833C11.3217 8.95833 11.0417 9.23833 11.0417 9.58333V11.0417H9.58333C9.23833 11.0417 8.95833 11.3217 8.95833 11.6667C8.95833 12.0117 9.23833 12.2917 9.58333 12.2917H11.0417V13.75C11.0417 14.095 11.3217 14.375 11.6667 14.375C12.0117 14.375 12.2917 14.095 12.2917 13.75V12.2917H13.75C14.095 12.2917 14.375 12.0117 14.375 11.6667Z"*/}
                    {/*        fill="black"*/}
                    {/*      />*/}
                    {/*    </svg>*/}
                    {/*    <p>Import private key</p>*/}
                    {/*  </div>*/}
                    {/*</div>*/}
                    <div className={s.wallet_block} onClick={onOpenCashOut}>
                      <div className={s.wallet_block_left}>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="none"
                        >
                          <path
                            d="M2.50121 9.83337C2.47871 9.83337 2.45542 9.83252 2.43209 9.83002C2.08876 9.79252 1.84126 9.48333 1.87876 9.14083C2.18126 6.37666 3.84957 3.99586 6.34124 2.77252C6.53541 2.67752 6.76456 2.68918 6.94706 2.80334C7.1304 2.91751 7.24207 3.11831 7.24207 3.33415V5.87585C7.24207 6.22085 6.96207 6.50085 6.61707 6.50085C6.27207 6.50085 5.99207 6.22085 5.99207 5.87585V4.42505C4.38957 5.54005 3.33871 7.2908 3.12204 9.27663C3.08704 9.5958 2.81538 9.83337 2.50121 9.83337ZM13.6596 17.2275C16.1512 16.005 17.8196 13.6242 18.1212 10.8592C18.1596 10.5158 17.9112 10.2075 17.5679 10.17C17.2279 10.1333 16.9171 10.38 16.8796 10.7234C16.6621 12.7092 15.6121 14.46 14.0087 15.575V14.1241C14.0087 13.7791 13.7287 13.4991 13.3837 13.4991C13.0387 13.4991 12.7587 13.7791 12.7587 14.1241V16.6659C12.7587 16.8817 12.8704 17.0825 13.0537 17.1967C13.1546 17.2592 13.2687 17.2909 13.3837 17.2909C13.4779 17.2917 13.5721 17.2708 13.6596 17.2275ZM10.0004 5.83333C10.0004 7.67417 11.4929 9.16667 13.3337 9.16667C15.1746 9.16667 16.6671 7.67417 16.6671 5.83333C16.6671 3.9925 15.1746 2.5 13.3337 2.5C11.4929 2.5 10.0004 3.9925 10.0004 5.83333ZM3.33373 14.1667C3.33373 16.0075 4.82623 17.5 6.66707 17.5C8.5079 17.5 10.0004 16.0075 10.0004 14.1667C10.0004 12.3258 8.5079 10.8333 6.66707 10.8333C4.82623 10.8333 3.33373 12.3258 3.33373 14.1667Z"
                            fill="black"
                          />
                        </svg>

                        <p>Withdraw</p>
                      </div>
                    </div>
                    {swapTC2BTCAble && (
                      <div
                        className={s.wallet_block}
                        onClick={onOpenEnterSwapTC}
                      >
                        <div className={s.wallet_block_left}>
                          <SvgInset
                            svgUrl={`${CDN_URL_ICONS}/swap-black.svg`}
                            size={20}
                          />
                          <p>Convert TC to BTC</p>
                        </div>
                      </div>
                    )}

                    {!isReferralFromAnother && (
                      <div
                        className={s.wallet_block}
                        onClick={onOpenEnterInviteCode}
                      >
                        <div className={s.wallet_block_left}>
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M14.1331 10.8334C14.6415 10.8334 15.0665 10.9667 15.4165 11.175C15.7032 11.0075 16.0415 10.8867 16.4331 10.8467C16.5631 10.8334 16.6665 10.7325 16.6665 10.6025V5.83337C16.6665 4.16671 15.8332 3.33337 14.1665 3.33337H4.1665C2.49984 3.33337 1.6665 4.16671 1.6665 5.83337V13.3334C1.6665 15 2.49984 15.8334 4.1665 15.8334H11.3333C11.5641 15.8334 11.6249 15.6275 11.5774 15.52C11.4666 15.2659 11.3832 14.9959 11.3249 14.7084C11.1166 13.6167 11.3416 12.575 11.9416 11.8334C12.4666 11.1917 13.2415 10.8334 14.1331 10.8334ZM10.024 10.1492C9.76738 10.3359 9.4665 10.4292 9.1665 10.4292C8.8665 10.4292 8.56479 10.3359 8.30896 10.15L4.21574 7.17254C3.93657 6.97004 3.87487 6.57838 4.07821 6.29921C4.28071 6.02171 4.66975 5.95754 4.95142 6.16171L9.04484 9.13838C9.11817 9.19088 9.21565 9.19171 9.28898 9.13838L13.3824 6.16171C13.6632 5.95754 14.0531 6.02088 14.2556 6.29921C14.459 6.57838 14.3973 6.9692 14.1181 7.17254L10.024 10.1492ZM18.2815 14.4617C17.9015 16.3892 15.4198 17.5 15.4198 17.5C15.4198 17.5 12.9382 16.39 12.5582 14.4617C12.3249 13.2792 12.8349 12.0892 14.1307 12.0834C15.0957 12.0792 15.4198 13.0359 15.4198 13.0359C15.4198 13.0359 15.744 12.0792 16.709 12.0834C18.0082 12.0892 18.5148 13.2792 18.2815 14.4617Z"
                              fill="white"
                            />
                          </svg>
                          <p>Enter invite code</p>
                        </div>
                      </div>
                    )}

                    {!hasNotiPermission && (
                      <div
                        className={s.wallet_block}
                        onClick={handleGetNotification}
                      >
                        <div className={s.wallet_block_left}>
                          <IcEnableNotification />
                          <p>Enable notifications</p>
                        </div>
                      </div>
                    )}

                    <div
                      className={s.wallet_block}
                      onClick={onOpenMinKeyRequirement}
                    >
                      <div className={s.wallet_block_left}>
                        <IcMenuMinKey />
                        <p>Minimum key requirement</p>
                      </div>
                    </div>

                    <div
                      className={s.wallet_block}
                      onClick={onOpenSettingCreatorFee}
                    >
                      <div className={s.wallet_block_left}>
                        <EnterInviteCodeIcon />
                        <p>Set up creator earnings</p>
                      </div>
                    </div>
                    <div
                      className={s.wallet_block}
                      onClick={handleAutoFollowHolding}
                    >
                      <div className={s.wallet_block_left}>
                        <IcAutoFollow />
                        <p>Auto follow profiles you are holding: <span style={{color: '#F8F0AC'}}>{poolProfile?.autoFollow ? 'On' : 'Off'}</span></p>
                      </div>
                    </div>
                  </MenuList>
                </Menu>
              </div>
            </div>
            <Box>
              <Flex
                alignItems={'center'}
                justifyContent={'space-between'}
                mb="16px"
              >
                <div className={s.wallet_info}>
                  <div
                    className={s.wallet_avatar}
                    onClick={() =>
                      router.push(
                        `${ROUTE_PATH.ALPHA_MOBILE_PROFILE}/${addressL2}`
                      )
                    }
                  >
                    {/* {userGameInfo && userGameInfo.pfpUrl ? (
                  <img className={s.avatar} src={userGameInfo.pfpUrl} />
                ) : (
                  <Jazzicon
                    diameter={54}
                    seed={jsNumberForAddress(addressL2 || '')}
                  />
                )} */}
                    {/* {poolProfile &&
                  (poolProfile.twitterAvatar || poolProfile.avatar) ? (
                    <img
                      className={s.avatar}
                      src={poolProfile.twitterAvatar || poolProfile.avatar}
                    />
                  ) : (
                    <Jazzicon
                      diameter={54}
                      seed={jsNumberForAddress(addressL2 || '')}
                    />
                  )} */}
                    {poolProfile && poolProfile.twitterAvatar && (
                      <Avatar
                        className={s.avatar}
                        url={poolProfile.twitterAvatar}
                        address={addressL2 || ''}
                        width={48}
                      />
                    )}
                  </div>
                  <div className={s.wallet_actions}>
                    <div
                      className={s.wallet_address}
                      onClick={() => {
                        copy(addressL2);
                        toast.remove();
                        toast.success('Copied');
                      }}
                    >
                      {poolProfile && (
                        <Flex flexDir={'column'} lineHeight="20px">
                          {poolProfile.twitterName ||
                            (poolProfile.twitterUsername &&
                              `@${poolProfile.twitterUsername}`) ||
                            poolProfile.bns ||
                            formatTCAddress(poolProfile.address || '')}

                          <Flex
                            alignItems={'center'}
                            as="span"
                            gap="4px"
                            fontSize={'12px'}
                          >
                            {formatTCAddress(poolProfile.address || '')}

                            <svg
                              className={cn('ic-copy', s.iconCopy)}
                              xmlns="http://www.w3.org/2000/svg"
                              width="12"
                              height="12"
                              viewBox="0 0 14 14"
                              fill="none"
                            >
                              <g clip-path="url(#clip0_13261_58171)">
                                <path
                                  d="M2.87109 3.5H8.94141C9.80219 3.5 10.5 4.19781 10.5 5.05859V11.1289C10.5 11.9897 9.80219 12.6875 8.94141 12.6875H2.87109C2.01031 12.6875 1.3125 11.9897 1.3125 11.1289V5.05859C1.3125 4.19781 2.01031 3.5 2.87109 3.5Z"
                                  stroke="#fff"
                                  stroke-linejoin="round"
                                />
                                <path
                                  d="M3.51367 3.5L3.5 2.84375C3.50115 2.43799 3.66285 2.04918 3.94977 1.76227C4.23668 1.47535 4.62549 1.31365 5.03125 1.3125H10.9375C11.4012 1.31387 11.8455 1.49869 12.1734 1.82658C12.5013 2.15447 12.6861 2.59879 12.6875 3.0625V8.96875C12.6863 9.37451 12.5246 9.76332 12.2377 10.0502C11.9508 10.3371 11.562 10.4988 11.1562 10.5H10.5"
                                  stroke="#fff"
                                  strokeLinecap="round"
                                  stroke-linejoin="round"
                                />
                              </g>
                              <defs>
                                <clipPath id="clip0_13261_58171">
                                  <rect
                                    width="14"
                                    height="14"
                                    fill="white"
                                    transform="matrix(-1 0 0 1 14 0)"
                                  />
                                </clipPath>
                              </defs>
                            </svg>
                          </Flex>
                        </Flex>
                      )}
                    </div>
                  </div>
                </div>
                <Flex gap={4}>
                  <div className={s.wallet_info_balance}>
                    <p className={s.balance}>
                      {formatCurrency(
                        balanceL2.amountBTCFormatted || '0',
                        0,
                        4
                      )}{' '}
                      BTC
                    </p>
                    <p
                      className={s.label}
                      onClick={() => {
                        copy(addressL2);
                        toast.success('Copied');
                      }}
                    >
                      <Flex
                        justifyContent={'flex-end'}
                        alignItems={'center'}
                        gap="2px"
                      >
                        $
                        {formatCurrency(
                          new BigNumber(
                            balanceL2?.amountBTCFormatted || 0
                          ).multipliedBy(poolProfile?.btcPrice || 0),
                          2,
                          2
                        )}
                      </Flex>
                    </p>
                  </div>
                  <button
                    onClick={handleOpenTopup}
                    className={`${s.topup} ${s.topup__primary}`}
                    disabled={fetchingOtp || loading}
                  >
                    {fetchingOtp || loading ? (
                      <Spinner size="md"></Spinner>
                    ) : (
                      'Deposit'
                    )}
                  </button>
                </Flex>
              </Flex>

              <Flex alignItems={'center'} gap="12px" className={s.hold_data}>
                <Box onClick={goToHolderDetail} cursor={'pointer'}>
                  {poolProfile?.holders} <span>Holders</span>
                </Box>
                <Box onClick={goToHoldingDetail} cursor={'pointer'}>
                  {poolProfile?.holding} <span>Holding</span>
                </Box>
                <Box onClick={goToOpenOrder} cursor={'pointer'}>
                  {poolProfile?.openLimitOrder}{' '}
                  <span>
                    Open order
                    {labelAmountOrNumberAdds(
                      poolProfile?.openLimitOrder as any
                    )}
                  </span>
                </Box>

                <Flex
                  alignItems={'center'}
                  gap={2}
                  className={s.btnSyncProfile}
                  onClick={handleSyncProfile}
                  color="rgba(0, 0, 0, 0.6)"
                >
                  {isSyncProfile ? (
                    <Spinner
                      speed="0.65s"
                      emptyColor="gray.200"
                      color="gray.500"
                    />
                  ) : (
                    <TbRefresh fontSize={'16px'} />
                  )}
                  Sync profile data
                </Flex>
              </Flex>
            </Box>
          </div>
        </div>

        {/* <BackupPrvKey /> */}
        {poolProfile && (
          <div className={s.wallet_balance_wrapper}>
            <div className={s.wallet_header}>
              <h5>Trade</h5>
            </div>
            <Grid
              gridTemplateColumns={'1fr 1fr'}
              gap="12px"
              alignItems={'center'}
            >
              <>
                <BlockItem
                  title={'Portfolio value'}
                  value={poolProfile.portfolio}
                  usdValue={portfolioValueUSDT}
                />
                <BlockItem
                  title={`Creator earnings (${formatFeePercent(
                    userProfile?.creator_fee
                  )}%)`}
                  value={poolProfile.earningFee}
                  usdValue={earningValueUSDT}
                />
              </>
            </Grid>
            {/* <div
              className={s.btn_cta}
              onClick={() => {
                router.push(ROUTE_PATH.ALPHA_MOBILE_KEYS);
              }}
            >
              <SvgInset size={20} svgUrl={`${CDN_URL_ICONS}/ic-trend-up.svg`} />
              Trade now
            </div> */}
          </div>
        )}

        <InviteAndRewards />
        {/*<VerifyFriendTech />*/}
      </div>
      {isOpenCashOut && (
        <WithdrawModal isOpen={isOpenCashOut} onClose={onCloseCashOut} />
      )}
      <EnterInviteCodeModal
        isOpen={isOpenEnterInviteCode}
        onClose={() => {
          getAddressReferrer().then(reference => {
            setIsReferralFromAnother(!!reference);
          });
          onCloseEnterInviteCode();
        }}
      />
      <SwapTcToBTCModal isOpen={isOpenSwapTC} onClose={onCloseEnterSwapTC} />

      {url && <PlayerSharesIframe url={url} setShow={setUrl} />}
      <MinKeyRequirement
        isOpen={isOpenMinKeyRequirement}
        onClose={onCloseMinKeyRequirement}
        poolProfile={poolProfile}
        fetchPlayerPoolProfile={fetchPlayerPoolProfile}
      />
      <SettingCreatorFee
        isOpen={isOpenSettingCreatorFee}
        onClose={onCloseSettingCreatorFee}
        poolProfile={poolProfile}
        fetchPlayerPoolProfile={fetchPlayerPoolProfile}
      />
    </PullableWrapper>
  );
};

const BlockItem = ({
  title,
  value,
  usdValue,
}: {
  title: string;
  value: string;
  usdValue: number;
}) => {
  return (
    <div className={s.block_wrapper}>
      <p className={s.block_title}>{title}</p>
      <p className={s.block_value}>{formatCurrency(value, 0, 6, 'BTC')} BTC</p>
      <p className={s.block_usd_value}>
        ${formatCurrency(usdValue, 2, 2, 'USD')}
      </p>
    </div>
  );
};

export default withPWAMiddleware(JackpotProfile);
